import { ChipProps, Chip as MuiChip } from '@material-ui/core';

export const Chip = (props: ChipProps) => {
  return <MuiChip {...props} />;
};
